import { defineMessages } from 'utils/intl';

export default defineMessages({
  item1: 'Komputery, laptopy, stacje robocze, monitory, akcesoria, oprogramowanie biurowe',
  item2:
    'Serwery, macierze, biblioteki taśmowe, przełączniki sieciowe, urządzenia bezpieczeństwa infrastruktury IT, zasilacze UPS',
  item3:
    'Usługi integracji, projektowania i zarządzania środowiskiem IT – wirtualizacja, backup, instalacja i aktualizacja oprogramowania, migracja danych',
});
